<template>
  <div class="d-flex align-items-center flex-grow-1">
    <!--begin::Avatar-->
    <div class="symbol symbol-45px me-5">
        <img
            class="symbol-label"
            :src="$getImage(author?.image)"
            alt=""
            v-if="author?.image"
        />
        <img
            src="@/assets/images/MotTruyen_LogoApp1.png"
            alt=""
            v-else
        />
    </div>
    <!--end::Avatar-->

    <!--begin::Info-->
    <div class="d-flex flex-column">
      <span class="bold text-dark ">{{ author?.name ?? 'Không xác định' }}</span>
      <span class="text-gray-400 fw-bold">#{{ author?.id }}</span>
      <span class="text-gray-400 fw-bold">{{ author?.email }}</span>
    </div>
    <!--end::Info-->
  </div>
</template>

<script>
export default {
  name: 'AuthorCard',
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
};
</script>
